import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDVRAMcYdmRWnCI6bjOX9QntZMhUcm61WY",
  authDomain: "quote-maker-680f7.firebaseapp.com",
  projectId: "quote-maker-680f7",
  storageBucket: "quote-maker-680f7.appspot.com",
  messagingSenderId: "182928965336",
  appId: "1:182928965336:web:d48eacb1bdcd0a1b3da1ad",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
